import {
  Activity,
  ActivityFeedItemDefinition,
} from "@ofqual/portal-activity-feed";
import { useSelector } from "react-redux";
import { ContactTheRegulator } from "../../../domain/ContactTheRegulator";
import { authSelector } from "../../../redux/selectors";
import { contactTheRegulatorService } from "../../../services";
import { AttachmentActivityBody, AttachmentBodyProps } from "./types";
import { DownloadLink } from "@ofqual/portal-components/components/DownloadLink";
import { ActivityType } from "../../../domain/ActivityType";
import ReactMarkdown from "react-markdown";

export const buildDefinitions = (
  setFocussedActivity: (activity: Activity) => void,
  contactTheRegulator: ContactTheRegulator
) => {
  const AttachmentBody: React.FC<AttachmentBodyProps> = ({ bodyProps }) => {
    const { body } = bodyProps;
    const { token } = useSelector(authSelector);

    const buildGetBlob = (blobId: string) => () =>
      contactTheRegulatorService.downloadActivityDocument(
        contactTheRegulator.id,
        bodyProps.activity.id,
        blobId,
        { token: token }
      );
    return (
      <>
        <ul style={{ padding: 0, marginLeft: 0, marginTop: 0 }}>
          {body.documents.map((document) => (
            <li key={document.blobId} style={{ listStyleType: "none" }}>
              <DownloadLink
                fileName={document.fileName}
                getBlob={buildGetBlob(document.blobId)}
              />
            </li>
          ))}
        </ul>
      </>
    );
  };

  const messageSentRegulator: ActivityFeedItemDefinition<AttachmentActivityBody> = {
    activityType: ActivityType.CtrMessageSentRegulator,
    Body: ({ body, activity }) => {
      return (
        <>
          {body.message ? (
            <div style={{ marginBottom: 15 }}>
              <b>Message: </b>
              <ReactMarkdown>{body.message}</ReactMarkdown>
            </div>
          ) : null}
          <AttachmentBody bodyProps={{ activity, body }} />
        </>
      );
    },
  };

  const messageSentAO: ActivityFeedItemDefinition<AttachmentActivityBody> = {
    activityType: ActivityType.CtrMessageSentAO,
    Body: ({ body, activity }) => {
      return (
        <>
          {body.message ? (
            <div style={{ marginBottom: 15 }}>
              <b>Message: </b>
              <ReactMarkdown>{body.message}</ReactMarkdown>
            </div>
          ) : null}
          <AttachmentBody bodyProps={{ activity, body }} />
        </>
      );
    },
    align: "left"
  };

  const closeCtr: ActivityFeedItemDefinition<{}> = {
    activityType: ActivityType.CtrClosed,
  };

  const assignCtrOfqual: ActivityFeedItemDefinition<{}> = {
    activityType: ActivityType.CtrAssignedOfqual,
  };

  const assignCtrCcea: ActivityFeedItemDefinition<{}> = {
    activityType: ActivityType.CtrAssignedCcea,
  };

  return [
    messageSentRegulator,
    messageSentAO,
    closeCtr,
    assignCtrOfqual,
    assignCtrCcea,
  ];
};
